import { NgModule } from '@angular/core';

import {ReportWidgetComponent} from './report-widget/report-widget.component';
import { CommonModule, DatePipe } from '@angular/common';
import {ShowFeatureDirective} from "./show-feature/show-feature.directive";
import { ReadMoreComponent } from './read-more/read-more.component';
import { RouterModule } from '@angular/router';
import { ResizeFilterWrapperDirective } from '../rpm/notifications/notification-directive/notification-filter.directive';
import { PersistentSidebarComponent } from './persistent-sidebar/persistent-sidebar.component';
import { ButtonModule } from 'primeng/button';
import { ReportComponent } from './report/report.component';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { PatientReviewComponent } from './patient-review/patient-review.component';
import { PatientChartsComponent } from '../ccm/patients/patient-charts/patient-charts.component';
import { SuperbillViewComponent } from './superbill/superbill-view.component';
import { TableLocaleDirective, PaginatorLocaleDirective } from './primeng-locale.directive';
import { PendoTabPagesDirective } from './pendo-tab-pages/pendo-tab-pages.directive';


@NgModule({
    declarations: [
        ReportWidgetComponent,
        ReadMoreComponent,
        ShowFeatureDirective,
        ResizeFilterWrapperDirective,
        PersistentSidebarComponent,
        ReportComponent,
        PatientReviewComponent,
        SuperbillViewComponent,
        TableLocaleDirective,
        PaginatorLocaleDirective,
        PendoTabPagesDirective
    ],
    exports: [
        ReportWidgetComponent,
        ReadMoreComponent,
        ShowFeatureDirective,
        ResizeFilterWrapperDirective,
        PersistentSidebarComponent,
        ReportComponent,
        PatientReviewComponent,
        SuperbillViewComponent,
        TableLocaleDirective,
        PaginatorLocaleDirective,
        PendoTabPagesDirective
    ],
    imports: [
        CommonModule,
        RouterModule,
        ButtonModule,
        TableModule,
        PaginatorModule,
        CheckboxModule,
        FormsModule,
        DatePipe,
        TooltipModule,
        PatientChartsComponent
    ]
})
export class SharedModule { }
